import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    sender: String,
    other: String,
    senderName: String,
    senderRole: String
  }

  connect() {
    if (this.senderRoleValue === "agent") {
      this.element.classList.add(...this.senderValue.split(' '))
      if (document.body.dataset.currentRole === "agent") {
        if (this.element.querySelector("#user-name")) {
          this.element.querySelector("#user-name").innerText = this.senderNameValue
        }
        this.element.querySelector("#user-name-private-icon")?.classList.remove("hidden")
      }
    } else {
      this.element.classList.add(...this.otherValue.split(' '))
    }
  }
}
